import Lang from '../../language/services/Lang'

class DisplayFormatters {
    static formatName = (profile) => {
        var name = profile.firstName || '';
        if (name && profile.lastName) {
            name += ' ';
        }
        if (profile.lastName) {
            name += profile.lastName
        }
        return name || '-'
    };

    static formatPhone = (profile) => {
        if (profile && profile.phoneNumber) {
            if (profile.phoneNumber.length < 4) {
                return profile.phoneNumber;
            } else if (profile.phoneNumber.length < 8) {
                var i = profile.phoneNumber.length - 4;
                return (i > 0 ? (profile.phoneNumber.substring(0, i) + '-') : '') + profile.phoneNumber.substring(i, profile.phoneNumber.length)
            } else {
                var ii = profile.phoneNumber.length - 4;
                var j = profile.phoneNumber.length - 7;
                return (j > 0 ? ('(' + profile.phoneNumber.substring(0, j) + ') ') : '') +
                    (ii > 0 ? (profile.phoneNumber.substring(j, ii) + '-') : '')
                    + profile.phoneNumber.substring(ii, profile.phoneNumber.length)
            }
        }
        return '';
    };

    static formatProvince = (profile, lang) => {
        if (profile && profile.province) {
            return Lang.getValue('common.provinces.' + profile.province.toLowerCase(), lang || 'en');
        }
        return ''
    }
};

export default DisplayFormatters;